<template>
	<div>
		<el-card class="table-card" shadow="always">
			<div>
				<el-empty v-if="progressList.length === 0" :image-size="100" description="暂无进度"></el-empty>
				<el-timeline v-else>
					<el-timeline-item
						v-for="item in progressList"
						:key="item.createTime"
						:timestamp="dayjs(item.createTime).format('YYYY-MM-DD')"
						placement="top"
						type="primary">
						<el-card>
							<div class="process">进度更新至 {{ item.progress }}%</div>
							<div class="desc">{{ item.progressDescription }}</div>
							<div class="name">操作人：{{ item.operator }}</div>
							<div class="file" v-if="item.attachments">
								<i class="fa fa-file-o" style="margin-right: 4px"></i>
								{{ item.attachments }}
							</div>
						</el-card>
					</el-timeline-item>
				</el-timeline>
			</div>
		</el-card>
	</div>
</template>

<script>
	import dayjs from 'dayjs';
	export default {
		name: 'AssetPlanProgressRecord',
		props: {
			progressList: {
				type: Array,
				default: () => [],
			},
		},
		methods: {
			dayjs,
		},
	};
</script>

<style scoped lang="scss">
	.table-card {
		margin-bottom: 15px;
	}
	.process {
		font-size: 14px;
	}
	.desc {
		font-size: 12px;
		margin: 5px 0;
	}
	.name {
		margin: 5px 0;
		font-size: 12px;
		color: #999;
	}
	.file {
		display: inline-block;
		margin-top: 5px;
		background: rgba(0, 0, 0, 0.05);
		padding: 5px 8px;
		border-radius: 5px;
		cursor: pointer;
	}
</style>
